// extracted by mini-css-extract-plugin
module.exports = {"page":"streaming_page__3Cgz9","section":"streaming_section__21YCA","inputGroup":"streaming_inputGroup__32-5v"};